import { __UrlParams } from "../../core";
import { store } from "../../core.Store";
import ProxiProvier from "../Proxi.Provider";

export default class ProxiMarlipin extends ProxiProvier {
  constructor() {
    super();
    this.name = "MARLIPIN";
  }

  isGameWrapperLoaded() {
    //@ts-ignore
    return typeof cbGameWrapper !== "undefined";
  }

  gameReady(): void {
    super.gameReady();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.isWrapperActive({
        data: {
          active: true,
        },
      });
    }
  }

  gameLoadingStarted(): void {
    super.gameLoadingStarted();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.gameLoadingStarted();
    }
  }

  gameLoadingEnded(): void {
    super.gameLoadingEnded();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.gameLoadingEnded();
    }
  }

  updateStake(_number: number): void {
    super.updateStake(_number);

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.stakeUpdate(_number);
    }
  }

  insufficientFunds(): void {
    super.insufficientFunds();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.insufficientFunds();
    }
  }

  gameExit(): void {
    super.gameExit();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.exitGame();
    }
  }

  gameReload(): void {
    super.gameReload();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.gameReload();
    }
  }

  sendWindowSize(_width: number, _height: number): void {
    super.sendWindowSize(_width, _height);

    if (!this.state.isNoWrapper && this.isGameWrapperLoaded()) {
      //@ts-ignore
      cbGameWrapper.gameResize(_width, _height);
    }
  }

  updateBalance(_number: number, _stake: number): void {
    super.updateBalance(_number, _stake);

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.balancesUpdate(_number, _stake);
    }
  }

  paytableDialogueOpened(): void {
    super.paytableDialogueOpened();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.paytableDialogueOpened();
    }
  }

  paytableDialogueClosed(): void {
    super.paytableDialogueClosed();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.paytableDialogueClosed();
    }
  }

  rulesDialogueOpened(): void {
    super.rulesDialogueOpened();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.rulesDialogueOpened();
    }
  }

  rulesDialogueClosed(): void {
    super.rulesDialogueClosed();

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.rulesDialogueClosed();
    }
  }

  visitLobby(): void {
    super.visitLobby();

    const lobby_URL = decodeURIComponent(__UrlParams.props.lobbyURL);
    //@ts-ignore
    window.top.location.href = lobby_URL;
  }

  visitHistory(): void {
    super.visitHistory();

    const historyLink =
      __UrlParams.props.historyURL +
      "?" +
      "siteID=" +
      __UrlParams.props.siteID +
      "&gameID=" +
      __UrlParams.props.gameID +
      "&fixedID=" +
      store.getState().game.SESSION_DATA.fixedID;

    window.open(historyLink, "_blank")?.focus();
  }

  visitRules(): void {
    super.visitRules();

    const rulesLink =
      __UrlParams.props.rulesURL +
      "?" +
      "siteID=" +
      __UrlParams.props.siteID +
      "&lang=" +
      __UrlParams.props.locale +
      "&gameID=" +
      __UrlParams.props.gameID;

    if (parseInt(__UrlParams.props.siteID) === 30) {
      window.location.href = rulesLink;
      return;
    }

    window.open(rulesLink, "_blank")?.focus();
  }

  visitCashier(): void {
    super.visitCashier();

    const deposit_URL = decodeURIComponent(
      __UrlParams.props.cashierURL || __UrlParams.props.depositURL
    );

    //@ts-ignore
    window.top.location.href = deposit_URL;
  }

  roundStart(_bet: number, _credit: number): void {
    super.roundStart(_bet, _credit);

    if (!this.state.isNoWrapper) {
      //@ts-ignore
      cbGameWrapper.setBusy(_bet);
    }
  }
}
